import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Button,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
} from "reactstrap";
import cross from "../../assets/img/cross.svg";
import Paypal from "../../components/PaypalPayment";
import {
    buyMomento,
    searchAthlete,
    submitMomentoRequest,
} from "../../store/actions/FanActions";
import { toast } from "react-toastify";

const MakeRequests = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.authUser);
    const [athelete, setAthelete] = useState("");
    const [athleteSearch, setAthleteSearch] = useState("");
    const [searchByLastName, setSearchByLastName] = useState("");

    const [searchByID, setSearchByID] = useState("");
    const [foundAthletes, setFoundAthletes] = useState([]);
    const [description, setDescription] = useState("");
    const [paymentModal, setPaymentModal] = useState(false);

    const onPurchaseSuccess = (order) => {
        let requestPayload = {
            athlete_name: athelete?.first_name + " " + athelete?.last_name,
            athlete_id: athelete?.id,
            athleteID: athelete?.athleteID,
            fan_name: user?.name,
            fan_id: user?.id,
            description,
            status: "pending",
        };
        dispatch(
            submitMomentoRequest(requestPayload, (res) => {
                let payload = {
                    amount: order?.purchase_units[0]?.amount,
                    payment_id: order.id,
                    athlete_id: athelete?.id,
                    athleteID: athelete?.athleteID,
                    fan_id: user?.id,
                    downloads: 0,
                    isPayout: false,
                    isRefunded: false,
                    type: "request",
                    requestId: res,
                    via: "paypal",
                };
                dispatch(
                    buyMomento(payload, () => {
                        toast.success("Request has been sent");
                        // setAtheleteID("");
                        setAthelete("");
                        setDescription("");
                        setPaymentModal(false);
                        window.location.reload();
                    })
                );
            })
        );
    };

    const handleSearch = (type, value) => {
        dispatch(
            searchAthlete(type, value, (res) => {
                if (res.length > 1) {
                    setFoundAthletes(res);
                } else {
                    setAthelete(res[0]);
                }
            })
        );
    };

    return (
        <Container fluid>
            <Row>
                <Col lg={8}>
                    {" "}
                    <Container>
                        <Row className="justify-content-end mx-4 py-3">
                            <Col
                                lg={6}
                                className="d-flex justify-content-center"
                            >
                                <h3>Make Requests</h3>
                            </Col>
                        </Row>
                    </Container>
                    <Container>
                        <Row className="justify-content-end">
                            <Col lg={6}>
                                <Form className="d-flex flex-column justify-content-center">
                                    <FormGroup>
                                        <Label for="exampleSelect">
                                            Select An Athlete
                                        </Label>
                                        <InputGroup>
                                            <Input
                                                type="text"
                                                value={athleteSearch}
                                                disabled={athelete}
                                                placeholder="Search Athlete by First Name"
                                                onChange={(e) => {
                                                    setAthleteSearch(
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                            <Button
                                                size="sm"
                                                color="primary"
                                                disabled={
                                                    !athleteSearch || athelete
                                                }
                                                onClick={() =>
                                                    handleSearch(
                                                        "name",
                                                        athleteSearch
                                                    )
                                                }
                                            >
                                                Search Athlete
                                            </Button>
                                        </InputGroup>
                                        <p className="text-center my-3">OR</p>
                                        <InputGroup>
                                            <Input
                                                type="text"
                                                value={searchByLastName}
                                                disabled={athelete}
                                                placeholder="Search Athlete by Last Name"
                                                onChange={(e) => {
                                                    setSearchByLastName(
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                            <Button
                                                size="sm"
                                                color="primary"
                                                disabled={
                                                    !searchByLastName ||
                                                    athelete
                                                }
                                                onClick={() =>
                                                    handleSearch(
                                                        "last_name",
                                                        searchByLastName
                                                    )
                                                }
                                            >
                                                Search Athlete
                                            </Button>
                                        </InputGroup>
                                        {foundAthletes.length > 0 &&
                                            foundAthletes?.map((item) => {
                                                return (
                                                    <div className="my-3">
                                                        <h5 className="text-center">
                                                            Found Athletes
                                                        </h5>
                                                        <p className="text-center text-danger cursor-pointer">
                                                            **Click your Athlete
                                                            to confirm**
                                                        </p>
                                                        <div
                                                            className="d-flex justify-content-around cursor-pointer my-3 border-bottom"
                                                            onClick={() =>
                                                                setAthelete(
                                                                    item
                                                                )
                                                            }
                                                        >
                                                            <p className="text-success mb-0">
                                                                <strong>
                                                                    {" "}
                                                                    {item?.first_name +
                                                                        " " +
                                                                        item?.last_name}
                                                                </strong>
                                                            </p>
                                                            <p className="text-success mb-0">
                                                                <strong>
                                                                    {" "}
                                                                    ID#{" "}
                                                                    {
                                                                        item?.athleteID
                                                                    }
                                                                </strong>
                                                            </p>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        <p className="text-center my-3">OR</p>

                                        <InputGroup>
                                            <Input
                                                type="text"
                                                value={searchByID}
                                                disabled={athelete}
                                                placeholder="Search Athlete by ID"
                                                onChange={(e) => {
                                                    setSearchByID(
                                                        e.target.value
                                                    );
                                                }}
                                            />
                                            <Button
                                                size="sm"
                                                color="primary"
                                                disabled={
                                                    !searchByID || athelete
                                                }
                                                onClick={() =>
                                                    handleSearch(
                                                        "ID",
                                                        searchByID
                                                    )
                                                }
                                            >
                                                Search Athlete
                                            </Button>
                                        </InputGroup>
                                    </FormGroup>
                                    {athelete && (
                                        <>
                                            <h5 className="text-center">
                                                Selected Athlete
                                            </h5>
                                            <div className="d-flex justify-content-around cursor-pointer align-items-center">
                                                <p className="text-success mb-1">
                                                    <strong>
                                                        {" "}
                                                        {athelete?.first_name +
                                                            " " +
                                                            athelete?.last_name}
                                                    </strong>
                                                </p>
                                                <p className="text-success mb-1">
                                                    <strong>
                                                        {" "}
                                                        ID#{" "}
                                                        {athelete?.athleteID}
                                                    </strong>
                                                </p>
                                                <img
                                                    src={cross}
                                                    alt="remove"
                                                    width={22}
                                                    onClick={() =>
                                                        setAthelete("")
                                                    }
                                                />
                                            </div>
                                        </>
                                    )}
                                    <FormGroup>
                                        <Label for="exampleText">
                                            Description
                                        </Label>
                                        <Col className="pl-0">
                                            <Input
                                                id="exampleText"
                                                name="text"
                                                type="textarea"
                                                value={description}
                                                placeholder="Write Down which type of photo or text or video you want the athlete to put in your momento "
                                                onChange={(e) =>
                                                    setDescription(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </Col>
                                    </FormGroup>
                                    <Button
                                        type="button"
                                        color="primary"
                                        className="my-3 px-4 mx-auto"
                                        onClick={() => {
                                            if (!athelete || !description) {
                                                toast.error(
                                                    "All Fields are mandatory"
                                                );
                                            } else {
                                                setPaymentModal(!paymentModal);
                                            }
                                        }}
                                    >
                                        Submit
                                    </Button>
                                    <Modal isOpen={paymentModal}>
                                        <ModalHeader
                                            toggle={() =>
                                                setPaymentModal(false)
                                            }
                                        >
                                            Memento Special Order
                                        </ModalHeader>
                                        <ModalBody>
                                            <h5 className="text-center">
                                                Memento Special Order will cost
                                                you $10 each Special Order. The
                                                Special-Order Memento will post
                                                to Gallery where download costs
                                                $20.
                                            </h5>
                                            <p className="text-danger text-center mb-3">
                                                <strong>NOTICE</strong>
                                            </p>
                                            <ol className="notice__list">
                                                <li>
                                                    After your athlete prepares
                                                    the Special-Order Memento,
                                                    he/she will post it to
                                                    Gallery
                                                </li>
                                                <li>
                                                    Then athlete will send you
                                                    an Email with memento ID# so
                                                    you can find it in Gallery.
                                                </li>
                                                <li>
                                                    Then if you like the
                                                    Special-Order Memento, you
                                                    can download it from gallery
                                                    for $20.
                                                </li>
                                                <li>
                                                    The Special-Order Memento
                                                    will also be available for
                                                    $20 download from Gallery by
                                                    any fan.
                                                </li>
                                            </ol>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button
                                                size="sm"
                                                color="primary"
                                                style={{ height: "2.2rem" }}
                                                onClick={() =>
                                                    setPaymentModal(false)
                                                }
                                            >
                                                Cancel
                                            </Button>
                                            <Paypal
                                                amount={10 + 0.5}
                                                onPurchaseSuccess={
                                                    onPurchaseSuccess
                                                }
                                            />
                                        </ModalFooter>
                                    </Modal>
                                </Form>
                            </Col>
                        </Row>
                    </Container>
                </Col>
                <Col lg={3} className="mt-5 ml-3">
                    <strong>Instructions:</strong>When you request a memento,
                    you can suggest to the athlete the type of photos you want,
                    the type of videos you want linked to the QR codes, any
                    personalized comments in the text you want above the photo.{" "}
                </Col>
            </Row>
        </Container>
    );
};

export default MakeRequests;
